import { Grid } from "@mui/material";
import Box from "@mui/material/Box";

import { theme } from "../../mui-customs/Theme";
import Typography from "../Typography";

interface Props {
  titleList: { title: string; date: string }[];
}

const GigTimingsTitle = ({ titleList }: Props) => {
  return (
    <Grid container spacing={2}>
      {titleList.map((data) => {
        return (
          <Grid item key={data.title} xs={4} lg={2}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
                height: "100%",
              }}
            >
              <Typography
                sx={{ color: theme.grey2[500], mb: "8px" }}
                variant="small5"
              >
                {data.title}
              </Typography>
              <Typography variant="small4">{data.date || "n/a"}</Typography>
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default GigTimingsTitle;
